import React, { useEffect, useState } from "react";
import styles from "./Content.module.scss";
import { getEnvs } from "../env";

const About: React.FC = () => {
	const [VERSION, setVERSION] = useState("");
	useEffect(() => {
		async function setServerUrl() {
			try {
				const envvars: any = await getEnvs();
				setVERSION(envvars.REACT_APP_VERSION);
			} catch (err) {
				setVERSION("");
			}
		}
		setServerUrl();
	}, []);
	return (
		<div className={styles.about}>
			<h3>Lineside Buildings Portal</h3>

      <p><b>Version:</b></p>

      <p>{VERSION}</p>
			<p>
				<b>Overview:</b>
			</p>

			<p>
				The LSB Locator Portal allows admin users to verify Lineside Buildings data submitted via the LSB Locator App,&nbsp;
				create new Lineside Buildings and export verified data in CSV format to be imported into the OPAS database.&nbsp;
				This will eradicate the use of ‘Unknown Buildings’ and ensure the Asset Portfolio data is correct and up to date.
			</p>

			<p>
				<b>Support:</b>
			</p>

			<p>
				For all questions and support enquiries please contact the Network Rail&nbsp;
				IT Helpdesk by calling:
			</p>

			<p>Internal: 085 51600</p>

			<p>External: 01270 721600</p>

			<p>
				<b>Digital Factory</b>
			</p>

			<p>
				To view our current projects, including designs and beta apps, visit&nbsp;
				<a href='https://nrdigital.co/labs' target="_blank" rel="noopener noreferrer">www.nrdigital.co/labs</a>
			</p>
			<p>
				<b>Have an idea?</b>
			</p>
			<p>
				If you have a new business problem that you need solving, or an idea you’d like to explore,&nbsp;
				get in touch with us at&nbsp;
				<a href='https://nrdigital.co/work-with-us' target="_blank" rel="noopener noreferrer">https://nrdigital.co/work-with-us</a>
			</p>
			<br />
			<br />
			<br />
			<br />
			<br />
			<p></p>
		</div>
	);
};

export default About;
